import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Phone, BellRing, ArrowRight } from "lucide-react";
import { getConsent } from "@/lib/consent";
import { openCallbackModal, trackEvent } from "@/lib/analytics";
import { COMPANY, telHref } from "@/data/company";

const PHONE = COMPANY.phone;

export default function StickyCta() {
  const { pathname } = useLocation();
  const [bannerVisible, setBannerVisible] = useState(
    () => false
  );

  useEffect(() => {
    setBannerVisible(!getConsent());
    const hide = () => setBannerVisible(false);
    const show = () => setBannerVisible(true);
    window.addEventListener("cookie-consent", hide);
    window.addEventListener("cookie-banner-shown", show);
    return () => {
      window.removeEventListener("cookie-consent", hide);
      window.removeEventListener("cookie-banner-shown", show);
    };
  }, []);

  if (pathname.startsWith("/admin") || pathname === "/devis" || bannerVisible) return null;

  return (
    <div
      data-testid="sticky-cta"
      className="fixed bottom-0 left-0 right-0 z-40 border-t-2 border-ink bg-paper lg:hidden"
    >
      <div className={`grid ${PHONE ? "grid-cols-3" : "grid-cols-2"}`}>
        {PHONE && (
          <a
            href={telHref(PHONE)}
            onClick={() => trackEvent("phone_click", { position: "sticky" })}
            data-testid="sticky-cta-phone"
            aria-label="Nous appeler"
            className="flex items-center justify-center border-r-2 border-ink bg-ink py-4 text-paper"
          >
            <Phone className="h-5 w-5" />
          </a>
        )}
        <button
          onClick={openCallbackModal}
          data-testid="sticky-cta-callback"
          className="flex items-center justify-center gap-2 border-r-2 border-ink py-4 font-mono text-[11px] uppercase tracking-[0.12em]"
        >
          <BellRing className="h-4 w-4 text-accent" />
          Être rappelé
        </button>
        <Link
          to="/devis"
          data-testid="sticky-cta-devis"
          className="flex items-center justify-center gap-2 bg-accent py-4 font-mono text-[11px] uppercase tracking-[0.12em] text-paper"
        >
          Obtenir mon devis
          <ArrowRight className="h-4 w-4" />
        </Link>
      </div>
    </div>
  );
}
